// removed by extract-text-webpack-plugin
module.exports = {"item":"devices-link__item___1BNWA","active":"devices-link__active___1iE_g","svg-path":"devices-link__svg-path___3GmMb","svgPath":"devices-link__svg-path___3GmMb"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/devices-link.css
// module id = 841
// module chunks = 0